<template>
  <div class="wizard-step-content wizard-step-geolayers">
    <ul class="u-reset wizard-step-content__group-list">
      <li
        v-for="(layerGroup, layerTypeId) in layerGroupList"
        :key="layerTypeId"
        class="wizard-step-geolayers__group"
      >
        <checkbox-list
          :items="layerGroup"
          :title="getLayerTypeLabel(layerTypeId)"
          :value.sync="activeLayerIds"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import { groupBy } from 'lodash-es'
  import { mapActions } from 'vuex'
  import { layerList, layerTypeIds, layerTypeList } from '@/assets/js/model/layer'
  import CheckboxList from '@/components/checkbox-list/checkbox-list'

  const EXCLUDED_GEOLAYER_IDS = []
  const EXCLUDED_GEOLAYER_TYPES = [
    layerTypeIds.META,
    layerTypeIds.PERSONA_JOURNEY,
    layerTypeIds.PERSONA_STATIONS,
  ]

  export default {
    components: { CheckboxList },
    props: {
      mapConfig: {
        type: Object,
        required: true,
      },
    },
    computed: {
      activeLayerIds: {
        get() {
          return this.mapConfig.layerIds
        },
        set(layerIds) {
          this.setMapConfig({
            ...this.mapConfig,
            layerIds,
          })
        },
      },
      layerGroupList() {
        const layerList = this.$options.layerList
          .filter(({ id }) => !EXCLUDED_GEOLAYER_IDS.includes(id))
          .filter(({ layerType }) => !EXCLUDED_GEOLAYER_TYPES.includes(layerType))
        return groupBy(layerList, (layer) => layer.layerType)
      },
    },
    methods: {
      ...mapActions('world-map', ['setMapConfig']),
      getLayerTypeLabel(layerTypeId) {
        const { label } = layerTypeList.find(({ id }) => id === layerTypeId)
        return this.$t(label)
      },
    },
    layerList,
  }
</script>

<style lang="scss" src="./_wizard-step-geolayers.scss" />
